import PageModel from '@/models/pageModel';

export class Subscriptions extends PageModel {
    static moduleName = 'subscriptions';
    static moduleEntityName = 'subscriptionEntity';
    static listTitle = 'Подписки';
    static createTitle = 'Добавление новой подписки';
    static editTitle = 'Изменение данных о подписке';
    static apiPrefix = 'subscriptions';
    static entityName = 'Подписка';
}